<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="标题">
              <a-input placeholder="请输入标题" v-model="queryParam.title"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="内容">
              <a-input placeholder="请输入内容" v-model="queryParam.content"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="图片地址">
                <a-input placeholder="请输入图片地址" v-model="queryParam.imgUrl"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="审核状态">
                <a-input placeholder="请输入审核状态" v-model="queryParam.status"></a-input>
              </a-form-item>
            </a-col>
            <!-- <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="租户id">
                <a-input placeholder="请输入租户id" v-model="queryParam.tenantId"></a-input>
              </a-form-item>
            </a-col> -->
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">
                重置
              </a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('系统通知')">导出</a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="imgUrl" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>

          <div class="faImage" v-else>
            <a-popover trigger="hover" placement="right">
              <template slot="content">
                <img
                  :src="getImgView(text)"
                  alt=""
                  style="width: 100%; height: 100%"
                  class="hahImage"
                />
              </template>
              <img
                :src="getImgView(text)"
                alt=""
                style="width: 100px; height: 100px"
                class="hahImage"
              />
            </a-popover>
          </div>
          <!-- <img
            v-else
            :src="getImgView(text)"
            @click="showImgDialog(getImgView(text))"
            height="80px"
            alt
            style="max-width:80px;font-size: 12px;font-style: italic;"
          /> -->
        </template>
        <template slot="status" slot-scope="text, record">
          <a-tag v-if="record.status == 1" color="green">已发布</a-tag>
          <a-tag v-else color="red">未发布</a-tag>
        </template>
        <span slot="action" slot-scope="text, record">
          <a v-if="!record.status" @click="publish(record)">发布</a>
          <a style="color: #ccc" v-else>发布</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <systemInform-modal ref="modalForm" @ok="modalFormOk"></systemInform-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import SystemInformModal from './modules/SystemInformModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, postAction, postActions } from '../../../api/manage'
import { message } from 'ant-design-vue'
export default {
  name: 'SystemInformList',
  mixins: [JeecgListMixin],
  components: {
    SystemInformModal,
  },
  data() {
    return {
      description: '系统通知管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '标题',
          align: 'center',
          dataIndex: 'title',
        },
        {
          title: '内容',
          align: 'center',
          dataIndex: 'content',
        },
        {
          title: '图片',
          align: 'center',
          dataIndex: 'imgUrl',
          scopedSlots: { customRender: 'imgUrl' },
        },
        {
          title: '审核状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        // {
        //   title: '租户id',
        //   align: 'center',
        //   dataIndex: 'tenantId',
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/systemInform/list?role=0',
        delete: '/systemInform/delete',
        deleteBatch: '/systemInform/deleteBatch',
        exportXlsUrl: '/systemInform/exportXls',
        importExcelUrl: '/systemInform/importExcel',
      },
    }
  },
  methods: {
    publish(record) {
      this.loading = true
      let params = {
        id: record.id,
        status: 1,
        title: record.title,
        content: record.content,
      }
      console.log(params)
      postAction('/systemInform/examine', params).then((res) => {
        message.success({ content: '发布成功!', duration: 1 })
        this.loading = false
        console.log(res)
        this.loadData()
      })
    },
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
